exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._3RCbd{margin:5px auto;padding:0 0 40px;margin-top:0 auto;max-width:1080px}._3VnfK{padding-left:0;padding-right:0;background-image:url(" + require("../../../../public/adminBG.jpg") + ");background-repeat:no-repeat;background-size:cover;background-attachment:scroll;background-position:50%;min-height:100vh;height:100%;width:100%;overflow:hidden;display:block}", ""]);

// exports
exports.locals = {
	"container": "_3RCbd",
	"root": "_3VnfK"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./~/postcss-loader?{"config":"./tools/postcss.config.js"}!./src/routes/siteadmin/adminLogin/AdminLogin.css
// module id = 2637
// module chunks = 15